import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CALLS_STAGES, DRAWER_KEY, FIREBASE_EVENTS } from 'app-constants'
import { InfoCard, Toggle } from 'components'
import { useFirebaseEvent } from 'hooks'
import { updatePaidCall } from 'slices/contract'
import { setDrawer, setStage } from 'slices/drawer'
import { STATICS } from 'statics'
import { formatPhone } from 'utils'
import './style.scss'

export function PhoneCard() {
  const {
    selected: { id: idContract },
    telephony,
  } = useSelector(state => state.contract)
  const phoneNumber = useSelector(state => state.contract.telephony?.phoneNumber)
  const { sendEvent } = useFirebaseEvent()
  const { collectCall = false, id: phoneId } = telephony || {}
  const dispatch = useDispatch()

  function handleToggle() {
    sendEvent(FIREBASE_EVENTS.TELEPHONY_COLLECT_CALL)
    dispatch(updatePaidCall({ idContract, phoneId, collectCall: !collectCall }))
  }

  function handleSeeAllCalls() {
    dispatch(setDrawer(DRAWER_KEY.CALLS))
  }

  function handleOpenCallsHistory() {
    dispatch(setDrawer(DRAWER_KEY.CALLS))
    dispatch(setStage(CALLS_STAGES.HISTORY))
  }

  function handleOpenCallsExtract() {
    dispatch(setDrawer(DRAWER_KEY.CALLS))
    dispatch(setStage(CALLS_STAGES.EXTRACT))
  }

  if (!phoneId) return null

  return (
    <InfoCard
      title={`Telefone ${formatPhone(phoneNumber)}`}
      actions={[
        {
          icon: <STATICS.CALL_HISTORY />,
          label: 'Histórico de ligações',
          onClick: handleOpenCallsHistory,
        },
        {
          icon: <STATICS.CALL_EXTRACT />,
          label: 'Extrato de ligações',
          onClick: handleOpenCallsExtract,
        },
      ]}
    >
      <div className='customer-phone-info'>
        <div className='collect-call'>
          <p>Receber ligações a cobrar</p>
          <div className='toggle-wrapper'>
            <Toggle
              className='toggle-collect-call'
              label={collectCall ? 'Habilitado' : 'Desabilitado'}
              checked={collectCall}
              onChange={handleToggle}
            />
          </div>
        </div>
        <button type='button' className='see-all-button' onClick={handleSeeAllCalls}>
          Ver todas
        </button>
      </div>
    </InfoCard>
  )
}
